export const DIRECT = 1;
export const SEQUENCE = 2;
export const SAMPLE = 3;
export const PRESET = 4;
